import React, {Component} from 'react';
import classNames from 'classnames';
import Icon from '../../Icon';

class SurveyEditorItem extends Component {
    constructor(props) {
        super(props);
        this.state = {expanded: props.expanded};

        this.toggleExpanded = this.toggleExpanded.bind(this);
    }

    toggleExpanded(e) {
        e.preventDefault();
        this.setState({expanded: !this.state.expanded});
        const {handleExpanded} = this.props;
        if (handleExpanded) {
            handleExpanded(this.props.index, !this.state.expanded);
        }
    }

    render() {
        const {children, header, index, name} = this.props;
        const suffix = name || index;
        return (
            <div className={classNames('survey-editor-item', {expanded: this.state.expanded})} id={`survey-editor-item-${suffix}`}>
                <header>
                    <button onClick={this.toggleExpanded} className="btn btn-link toggle">
                        { this.state.expanded ? <Icon icon="arrow-alt-down" /> : <Icon icon="arrow-alt-up" />}
                    </button>
                    {header}
                </header>
                {this.state.expanded && <div className="body">{children}</div>}
            </div>
        );
    }
}

export default SurveyEditorItem;
